import { Component, Input, OnChanges } from '@angular/core';
import { kebabCase } from 'lodash';

@Component({
  selector: 'digital-platform-status-chip',
  templateUrl: './status-chip.component.html',
  styleUrls: ['./status-chip.component.scss'],
})
export class StatusChipComponent implements OnChanges {
  @Input() status: string; // TODO: tonte re-factor check incoming variable for status attribute that should be stateApprovalWasteCodeNotApplicable
  @Input() label: string;

  public statusClass: string;

  ngOnChanges(): void {
    this.statusClass = '';
    if (this.status) {
      this.statusClass = kebabCase(this.status);
    }

    if (!this.label && this.status) {
      this.label = this.status;
    }
  }
}
